import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";
import { SITE } from "@/data/site";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full rounded-md border border-[#553204]/15 bg-white px-4 py-3 text-sm outline-none focus:border-[#F49E1A]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#361E02] px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={SITE.logo} alt="VacanzaGo" className="h-14 mx-auto bg-white rounded-md p-2" />
          <p className="eyebrow text-[#D4AF37] mt-5">Staff Portal</p>
        </div>
        <form onSubmit={submit} className="rounded-md bg-[#FFFBF5] p-8 space-y-4" data-testid="admin-login-form">
          <h1 className="font-display text-3xl text-[#2A1808] flex items-center gap-2"><Lock size={22} className="text-[#F49E1A]" /> Sign in</h1>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded px-3 py-2" data-testid="login-error">{error}</p>}
          <input data-testid="login-email" className={input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" className={input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button disabled={busy} data-testid="admin-login-submit" className="w-full rounded-full btn-orange px-5 py-3 text-sm disabled:opacity-60">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
